import React from "react";
import "./PdfViewer.css";

export default function PdfViewer({ gdriveId }) {
  const pdfUrl = `https://drive.google.com/file/d/${gdriveId}/preview`;

  return (
    <div className="pdfviewer-container">
      {/* Header */}
      <header className="pdfviewer-header">
        <a
          className="pdfviewer-back-btn"
          onClick={() => window.history.back()}
          title="Back"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="28"
            height="28"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="pdfviewer-icon"
          >
            <polyline points="15 18 9 12 15 6"></polyline>
          </svg>
        </a>

        <h1 className="pdfviewer-title">
          {window.location.pathname}
        </h1>
      </header>

      {/* Iframe area – truly full height */}
      <div className="pdfviewer-content">
        <iframe
          src={pdfUrl}
          title="PDF Viewer"
          className="pdfviewer-iframe"
          allow="autoplay"
        ></iframe>
      </div>

      {/* Footer */}
      <footer className="pdfviewer-footer">
        © {new Date().getFullYear()} TilboApps. All rights reserved.
      </footer>
    </div>
  );
}
